import { render, staticRenderFns } from "./JoinAgree.vue?vue&type=template&id=4e2fb1c5&scoped=true"
import script from "./JoinAgree.vue?vue&type=script&lang=js"
export * from "./JoinAgree.vue?vue&type=script&lang=js"
import style0 from "./JoinAgree.vue?vue&type=style&index=0&id=4e2fb1c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2fb1c5",
  null
  
)

export default component.exports